import { createAction } from 'redux-starter-kit';
import api from 'api';
import { setFirmConfig } from 'store/modules/Firm/actions';

export const SET_IS_LOADING_META = 'meta/loading-meta';
export const META_LOADED = 'meta/meta-loaded';
export const GET_META_TIME_HORIZON = 'meta/time-horizon';
export const GET_META_RISK_LEVEL = 'meta/risk-level';
export const GET_META_ASSET_CLASS = 'meta/asset-class';
export const GET_META_KNOWLEDGE_LEVEL = 'meta/knowledge-level';
export const GET_META_POLICY_PROVIDER = 'meta/policy-provider';
export const GET_META_POLICY_TYPE = 'meta/policy-type';
export const GET_META_POLICY_PLATFORM = 'meta/policy-platform';
export const GET_META_POLICY_CHARGE_TYPE = 'meta/policy-charge-type';
export const GET_META_RISK_ASSET_ALLOCATION = 'meta/risk-asset-allocation';
export const GET_META_RETURN_FORECASTS = 'meta/return-forecasts';
export const GET_META_RETURN_FORECAS_TYPES = 'meta/return-forecast-types';
export const GET_META_RISK_CAPACITY = 'meta/risk-capacity';
export const GET_RISK_REQUIREMENT_LEVELS = 'meta/risk-requirement-levels';
export const GET_META_POLICY_ACTION_TYPE = 'meta/policy-action-types';
export const SET_META_CONTRIBUTION_ACCOUNTS = 'meta/contribution-accounts';
export const SET_META_CONTRIBUTION_FREQUENCIES =
  'meta/contribution-frequencies';
export const SET_META_CONTRIBUTION_SOURCES = 'meta/contribution-sources';
export const SET_META_ADVISOR_CHARGE_TYPES = 'meta/advisor-charges-types/';
export const SET_META_ADVISOR_CHARGE_ACCOUNTS =
  'meta/advisor-charges-accounts/';
export const SET_RISK_DESCRIPTIONS = 'meta/risk-descriptions';
export const SET_META_ASSET_CLASSES = 'meta/asset-classes';
export const SET_META_CIP_THRESHOLDS = 'meta/cip-thresholds';
export const SET_MODEL_PORTFOLIOS = 'meta/model-portfolios';
export const SET_POLICY_TYPE_RECOMMENDED = 'meta/policy-type-cip';
export const SET_CHARGE_SOURCES = 'meta/charge-sources';
export const SET_BENCHMARKS = 'meta/benchmarks';
export const SET_CASH_FUND = 'meta/cash-fund';
export const SET_BENCHMARK_CONFIG = 'meta/benchmark-config';

const getMetaRiskCapacity = createAction(GET_META_RISK_CAPACITY);
const getMetaTimeHorizon = createAction(GET_META_TIME_HORIZON);
const getMetaRiskLevel = createAction(GET_META_RISK_LEVEL);
const getMetaAssetClass = createAction(GET_META_ASSET_CLASS);
const getMetaKnowledgeLevel = createAction(GET_META_KNOWLEDGE_LEVEL);
const getMetaPolicyProvider = createAction(GET_META_POLICY_PROVIDER);
const getMetaPolicyType = createAction(GET_META_POLICY_TYPE);
const getMetaPolicyPlatform = createAction(GET_META_POLICY_PLATFORM);
const getMetaPolicyChargeType = createAction(GET_META_POLICY_CHARGE_TYPE);
const getMetaRiskAssetAllocation = createAction(GET_META_RISK_ASSET_ALLOCATION);
const getMetaReturnForecasts = createAction(GET_META_RETURN_FORECASTS);
const getMetaReturnForecastTypes = createAction(GET_META_RETURN_FORECAS_TYPES);
const getMetaRiskRequirementLevels = createAction(GET_RISK_REQUIREMENT_LEVELS);
const getPolicyActionTypes = createAction(GET_META_POLICY_ACTION_TYPE);
const setContributionAccounts = createAction(SET_META_CONTRIBUTION_ACCOUNTS);
const setContributionFrequencies = createAction(
  SET_META_CONTRIBUTION_FREQUENCIES
);
const setContributionSources = createAction(SET_META_CONTRIBUTION_SOURCES);
const metaLoaded = createAction(META_LOADED);
const setIsLoadingMeta = createAction(SET_IS_LOADING_META);
const setAdvisorChargeTypes = createAction(SET_META_ADVISOR_CHARGE_TYPES);
const setAdvisorChargeAccounts = createAction(SET_META_ADVISOR_CHARGE_ACCOUNTS);
const setRiskDescriptions = createAction(SET_RISK_DESCRIPTIONS);
const setAssetClasses = createAction(SET_META_ASSET_CLASSES);
const setCipThresholds = createAction(SET_META_CIP_THRESHOLDS);
const setModelPortfolios = createAction(SET_MODEL_PORTFOLIOS);
const setPolicyTypeRecommended = createAction(SET_POLICY_TYPE_RECOMMENDED);
const setChargeSources = createAction(SET_CHARGE_SOURCES);
const setBenchmarks = createAction(SET_BENCHMARKS);
const setCashFund = createAction(SET_CASH_FUND);
const setBenchmarkConfig = createAction(SET_BENCHMARK_CONFIG);

export const metaActions = {
  updateModelPortfolios: (modelPortfolios: any) => (dispatch: any) => {
    dispatch(setModelPortfolios(modelPortfolios));
  },
  updateMetaReturnForecasts: (returnForecasts: any) => (dispatch: any) => {
    dispatch(getMetaReturnForecasts(returnForecasts));
  },
  updateAssetClasses: (assetClasses: any) => (dispatch: any) => {
    dispatch(setAssetClasses(assetClasses));
  },
  updateBenchmarks: (benchmarks: any) => (dispatch: any) => {
    dispatch(setBenchmarks(benchmarks));
  },
  updateCashFund: (cashFund: any) => (dispatch: any) => {
    dispatch(setCashFund(cashFund));
  },
  updateBenchmarkConfig: (benchmarks: any) => (dispatch: any) => {
    dispatch(setBenchmarkConfig(benchmarks));
  },
  getMetaData: () => (dispatch: any) => {
    dispatch(setIsLoadingMeta(true));
    return Promise.all([
      api.getMetaAssetClass(),
      api.getMetaKnowledgeLevel(),
      api.getMetaPolicyType(),
      api.getMetaPolicyChargeType(),
      api.getMetaPolicyPlatform(),
      api.getMetaPolicyProvider(),
      api.getMetaRiskAssetAllocation(),
      api.getMetaRiskLevel(),
      api.getMetaTimeHorizon(),
      api.getMetaReturnForecasts(),
      api.getMetaReturnForecastTypes(),
      api.getMetaRiskCapacity(),
      api.getRiskRequirementLevels(),
      api.getPolicyActionTypes(),
      api.getContributionAccounts(),
      api.getContributionFrequencies(),
      api.getContributionSources(),
      api.getAdvisorChargesTypes(),
      api.getAdvisorChargesAccounts(),
      api.getFirmRiskDescriptions(),
      api.getAssetClasses(),
      api.getCipThresholds(),
      api.getFirmConfig(),
      api.getMetaPolicyTypeForRecommended(),
      api.getChargeSources(),
      api.getBenchmarks(),
      api.getCashFund()
    ]).then(
      ([
        aseetClasses,
        knowledgeLevels,
        policyTypes,
        policyChargeTypes,
        policyPlatforms,
        policyProviders,
        riskAssetAllocations,
        riskLevels,
        timeHorizons,
        returnForecasts,
        returnForecastTypes,
        riskCapacity,
        riskRequirementLevels,
        policyActionTypes,
        contributionAccounts,
        contributionFrequencies,
        contributionSources,
        advisorChargeTypes,
        advisorChargeAccounts,
        riskDescriptions,
        assetClasses,
        cipThresHolds,
        firmConfig,
        policyTypesRecommended,
        chargeSources,
        benchmarks,
        cashFund
      ]) => {
        dispatch(getMetaAssetClass(aseetClasses));
        dispatch(getMetaKnowledgeLevel(knowledgeLevels));
        dispatch(getMetaPolicyType(policyTypes));
        dispatch(getMetaPolicyChargeType(policyChargeTypes));
        dispatch(getMetaPolicyPlatform(policyPlatforms));
        dispatch(getMetaPolicyProvider(policyProviders));
        dispatch(getMetaRiskAssetAllocation(riskAssetAllocations));
        dispatch(getMetaRiskLevel(riskLevels));
        dispatch(getMetaTimeHorizon(timeHorizons));
        dispatch(getMetaReturnForecasts(returnForecasts));
        dispatch(getMetaReturnForecastTypes(returnForecastTypes));
        dispatch(getMetaRiskCapacity(riskCapacity));
        dispatch(getMetaRiskRequirementLevels(riskRequirementLevels));
        dispatch(getPolicyActionTypes(policyActionTypes));
        dispatch(setContributionAccounts(contributionAccounts));
        dispatch(setContributionFrequencies(contributionFrequencies));
        dispatch(setContributionSources(contributionSources));
        dispatch(setAdvisorChargeTypes(advisorChargeTypes));
        dispatch(setAdvisorChargeAccounts(advisorChargeAccounts));
        dispatch(setRiskDescriptions(riskDescriptions));
        dispatch(setAssetClasses(assetClasses));
        dispatch(setCipThresholds(cipThresHolds));
        dispatch(setFirmConfig(firmConfig));
        dispatch(setPolicyTypeRecommended(policyTypesRecommended));
        dispatch(setChargeSources(chargeSources));
        dispatch(setBenchmarks(benchmarks));
        dispatch(setCashFund(cashFund));
        dispatch(metaLoaded(true));
        dispatch(setIsLoadingMeta(false));
      }
    );
  }
};
